import { render, staticRenderFns } from "./RichCheckbox.vue?vue&type=template&id=7a05cc10&"
import script from "./RichCheckbox.vue?vue&type=script&lang=js&"
export * from "./RichCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RichTextRenderReplacer: require('/opt/build/repo/components/common/RichTextRenderReplacer.vue').default})
